import type { ComponentProps } from 'react';
import { RoundedButton } from '../../../../components/form/Button';
import TextArea from '../../../../components/form/TextArea';
import LoadingSpinner from '../../../../components/loadingSpinner/LoadingSpinner';

export const MAX_COMMENT_LENGTH = 600;
export const commentContainerClasses = 'bg-gray-outline p-1 border rounded-lg';

type RoundedButtonProps = ComponentProps<typeof RoundedButton>;

interface CommentInputProps {
    value: string;
    onValueChange: (value: string) => void;
    onAction: NonNullable<RoundedButtonProps['onClick']>;
    actionButtonLabel: string;
    onCancel: NonNullable<RoundedButtonProps['onClick']>;
    isAdding?: boolean;
    error?: string;
    isLoading?: boolean;
}

export function CommentInput({
    value,
    onValueChange,
    onAction,
    actionButtonLabel,
    onCancel,
    isAdding = true,
    error,
    isLoading = false,
}: CommentInputProps): JSX.Element {
    return (
        <>
            <div className={`${isAdding ? '' : commentContainerClasses}`}>
                {!isAdding && <p className="text-oslo-gray text-left">{gettext('EDITING')}</p>}
                <TextArea
                    value={value}
                    onValueChange={onValueChange}
                    maxLength={MAX_COMMENT_LENGTH}
                />
            </div>
            <div className="mt-2 space-x-3">
                <RoundedButton type="button" onClick={onAction} variant="big" color="primary" flex>
                    {isLoading ? <LoadingSpinner size="lg" /> : actionButtonLabel}
                </RoundedButton>
                <RoundedButton
                    type="button"
                    onClick={onCancel}
                    variant="big"
                    color="secondary"
                    flex
                >
                    {gettext('CANCEL')}
                </RoundedButton>
                {error && <p>{error}</p>}
            </div>
        </>
    );
}
export default CommentInput;
